import { render, staticRenderFns } from "./MarkedProductIndicator.vue?vue&type=template&id=75d0c8d8&"
import script from "./MarkedProductIndicator.vue?vue&type=script&lang=js&"
export * from "./MarkedProductIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports